import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Avatar, AppBar, CircularProgress, Button, Box, Card, CardActions, CardContent, Chip, Fab, Container, Divider, Drawer, 
  Paper, Typography, TextField, Grid,
  Table, TableContainer, TableCell, TableHead, TableBody, TableRow, TableSortLabel, 
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { AppHelper } from '../AppHelper';
import SpaCheck from './common/spa-check';
const dayjs = require('dayjs');

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function ImageDialog({ open, imageUrls, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
	 <DialogTitle>Feedback Image</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={3}>
          {imageUrls ? (
            imageUrls.map((imageUrl, index) => (
              <Grid item key={index} xs={6} sm={4} md={3}>
                <img src={`data:image/jpeg;base64,${imageUrl}`} alt={`Image ${index + 1}`} style={{ maxWidth: '100%' }} />
              </Grid>
            ))
          ) : (
            <CircularProgress />
          )}
        </Grid>
      </DialogContent>
	  <Button onClick={onClose} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseIcon />
      </Button>
    </Dialog>
  );
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsEssay = [
  { id: 'createdOn', numeric: false, disablePadding: false, label: 'TIMESTAMP' },
  { id: 'profileId', numeric: false, disablePadding: false, label: 'USER' },  
  { id: 'essayId', numeric: false, disablePadding: false, label: 'ESSAY' },
  { id: 'feedback', numeric: false, disablePadding: false, label: 'FEEDBACK' },
  { id: 'feedbackType', numeric: false, disablePadding: false, label: 'FEEDBACK TYPE' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'ACTIONS' }
 
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const headCells = headCellsEssay ;


  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageSaUserLogList() {

  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  
  const [imageUrls, setImageUrls] = useState([]);

  
  const [isLoading, setIsLoading] = useState(true);
  const [logList, setLogList] = useState([]);
  
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs());
  const [dateRange, setDateRange] = React.useState([dayjs().subtract(7, 'day'), dayjs()]);

  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  const handleStartDateChange = (date) => {
	  setStartDate(date);
	  if (endDate && date && endDate < date) {
		setEndDate(date);
	  }
	  else if(!endDate)
	  {
		  setEndDate(date);
	  }
	};

	const handleEndDateChange = (date) => {
	  setEndDate(date);
	  if (startDate && date && date < startDate) {
		setStartDate(date);
	  }
	  else if(!startDate)
	  {
		  setStartDate(date);
	  }
	};

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('LIST');
  const [refreshList, setRefreshList] = React.useState(false);
  const [countEssay, setCountLog] = React.useState(0);

  const [tblOrderLog, setTblOrderLog] = React.useState('desc');
  const [tblOrderByLog, setTblOrderByEssay] = React.useState('tCode');
  const [filterLog, setFilterLog] = React.useState('');

  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
  });
  
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleViewIconClick = async (row) => {
    setSelectedRow(row);
	var _res = await AppHelper.apiPost('api/feedback/detail', {token: oUser.token, feedbackId:row.feedbackId});
	if(!_res || !_res.status){
        setImageUrls([]);
		alert("No image for this feedback");
        return;
    }
	else
	{
		setImageUrls(_res.feedback.imgsBase64);		
		setIsPopupOpen(true);
	}
  };

    const handleCloseDialog = () => {
    setIsPopupOpen(false);
    setImageUrls([]);
  };


  useEffect(()=>{
    const fetchLogList = async() =>{
      logList.splice(0);
      setIsLoading(true);
      var _res = await AppHelper.apiPost('api/feedback/list', {token: oUser.token, startDate:dateRange[0], endDate:dateRange[1]});
      if(!_res || !_res.status){
        setIsLoading(false);
        return;
      }
	  
      var _list = [...AppHelper.sortList(_res.feedbackList, 'createdOn', 2)];
      _list.forEach(r=>{
        r.words = r.feedback.split(' ');
        r.isLongText = r.words.length>100;
        r.isExpanded = false;
      });
      setLogList(_list);
      setIsLoading(false);
      setCountLog(_list.length);
    };
   
		fetchLogList();
  }, [refreshList, startDate, endDate]);

  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  const listSortAndFilterEssay = ()=>{
    var _list = [...logList];
    if(filterLog && filterLog.length>0){
      var _filterText = filterLog.toLowerCase();
      _list = _list.filter(r=>
        r.profileId.toLowerCase().includes(_filterText)
        || r.feedback.toLowerCase().includes(_filterText)
		|| r.essayId.toLowerCase().includes(_filterText)
        || r.feedbackType.toLowerCase().includes(_filterText)
      );
    }
    return stableSort(_list, getComparator(tblOrderLog, tblOrderByLog));
  };
  const filterLogChange = (event)=>{
    setFilterLog(event.target.value);
  };
  
   const backToOverview = ()=>{
	navigate('/sa');
  }
  const visibleLogs = React.useMemo(
    () =>
      listSortAndFilterEssay()
      ,
    [logList, tblOrderLog, tblOrderByLog, filterLog]
  );
  const tblSortLog = (event, property) => {
    const isAsc = tblOrderByLog === property && tblOrderLog === 'asc';
    setTblOrderLog(isAsc ? 'desc' : 'asc');
    setTblOrderByEssay(property);
  };
  const toggleExpanded = (arg)=>{
    var _list = [...logList];
    var _rec = _list.find(x=>x.feedbackId==arg.feedbackId);
    if(!_rec) return;
    _rec.isExpanded = !_rec.isExpanded;
    setLogList(_list);
  }

  return (
    <Box sx={{display:'flex'}}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading? (
        <AppLoading />
      ):(
      <>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, 
          width: '100%',
          marginTop:'50px' 
        }}
      >
        { viewMode=='LIST' &&
          <>
            <Grid container  spacing={0}>
			  <Grid container>
              <Grid item xs={6} sm={6}>
                <Button onClick={backToOverview}>&laquo; Back to Overview</Button>
              </Grid>
              <Grid item xs={6} sm={6}>
              </Grid>
            </Grid>
			
			   <Grid item xs={3} sm={6}>
				 <Box m={.5} pt={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker 
					    format="DD/MM/YYYY"
              localeText={{ start: 'Start Date', end: 'End Date' }}
              value={dateRange}
              onChange={(newValue) => {
                setDateRange(newValue);
                handleStartDateChange(newValue[0]);
                handleEndDateChange(newValue[1]);
              }}
              renderInput={(startProps, endProps) => (
                <>
                <TextField {...startProps} sx={{width: '100%'}}/>
                <Box sx={{mx: 5}}> to </Box>
                <TextField {...endProps} sx={{width: '100%'}}/>
                </>
              )}
              />
          </LocalizationProvider>
				 </Box>
			  </Grid>
              <Grid item xs={6} sm={6}>
			   <Box m={.5} pt={1}>
                <TextField value={filterLog} onChange={filterLogChange} id="txtFilterLog" label="" variant="standard" placeholder="Search" fullWidth />
				</Box>
              </Grid>
            </Grid>
			
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <EnhancedTableHead
                  order={tblOrderLog}
                  orderBy={tblOrderByLog}
                  onRequestSort={tblSortLog}
                  rowCount={logList.length}
                  gid='G1'
                />
                <TableBody>
                  {visibleLogs.map((row) => (
                    <TableRow
                      key={row.logId}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left">{new Date(row.createdOn).toLocaleString()}</TableCell>
                     
                      <TableCell align="left">{row.profileId}</TableCell>
					  <TableCell align="left">{row.essayId}</TableCell>
                      <TableCell align="left">
                        {row.isExpanded || !row.isLongText ? row.feedback : row.words.slice(0, 10).join(" ") + "..."}
                        {row.isLongText && (
                          <span onClick={()=>toggleExpanded(row)} style={{ color: "blue", cursor: "pointer" }}>
                            {row.isExpanded ? " Show Less" : " Show More"}
                          </span>
                        )}
                      </TableCell>
                      <TableCell align="left">{row.feedbackType}</TableCell>
						<TableCell >
						  {row.imgs > 0 && (
							<IconButton onClick={() => handleViewIconClick(row)}>
							  <VisibilityIcon />
							</IconButton>
						  )}
						</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        }
        
      </Box>
	  <ImageDialog open={isPopupOpen} imageUrls={imageUrls} onClose={handleCloseDialog} />
      </>
      )}
      <SpaCheck></SpaCheck>
    </Box>
  );
}
